export const searchConstants = {
  TEXT_ANSWER_LIMIT: 10,
  OTHER_SEARCH_FORM: 'https://share.hsforms.com/1iukNeNvURrmyTzMopde-og2d97o',
  EDUCATION_TYPE_QUESTION: 'What area of interest would you like to pursue?',
  PROGRAM_TYPE_QUESTION: 'What are you searching for?',
};
